import { useModal, create, show } from "@ebay/nice-modal-react";
import { useMutation } from "@apollo/client";

import useTypedContext from "hooks/useTypedContext";
import FlashContext from "components/FlashMessages/FlashContext";
import DeleteConfirmationModal from "ds/components/DeleteConfirmationModal";

import { DELETE_VERSION } from "./gql";
import { REFETCH_QUERIES_LIST } from "./constants";

type DeleteConfirmationProps = {
  id: string;
  version: string;
};

const DeleteConfirmation = create(function DeleteConfirmation({
  id,
  version,
}: DeleteConfirmationProps) {
  const { onError, reportSuccess } = useTypedContext(FlashContext);

  const modal = useModal();

  const [deleteTemplate, { loading, data }] = useMutation(DELETE_VERSION, {
    refetchQueries: REFETCH_QUERIES_LIST,
    awaitRefetchQueries: true,
    variables: { id },
  });

  const handleDeleteTemplate = () => {
    deleteTemplate()
      .then(() => {
        reportSuccess({
          message: `Version "${version}" successfully deleted`,
        });
        modal.resolve();
        modal.hide();
      })
      .catch(onError);
  };

  return (
    <DeleteConfirmationModal
      title="Delete version"
      name={version}
      onConfirm={handleDeleteTemplate}
      isLoading={loading}
      isDismissable={!loading && !data?.blueprintVersionDelete?.id}
    />
  );
});

export const showDeleteConfirmation = (props: DeleteConfirmationProps) =>
  show(DeleteConfirmation, props);
